import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const waitForEditionChangeQuery: GraphQLTaggedNode = graphql`
	query waitForEditionChangeQuery {
		tenant: confluence_tenantContext {
			editions {
				confluence
			}
		}
	}
`;
